export default function Practices() {
  return (
    <section id="pratiques" className="cadence-practices">
      <div className="container">
        <div className="chapter-heading">
          <div>
            <p className="story-eyebrow">Votre coaching, votre terrain</p>
            <h2 className="landing-section-title">En salle. À distance.<br /><span>Toujours présent.</span></h2>
          </div>
          <p>Votre méthode, votre relation client. CoachOS vous aide à garder le fil entre les séances.</p>
        </div>
        <figure className="practice-photo">
          <img src="/art/coaching-outdoors.webp" alt="Une coach et son client échangent après une séance sur une piste de course" loading="lazy" width={1536} height={1024} />
          <figcaption><span>EN SALLE. DEHORS. À DISTANCE.</span><strong>Le terrain change.<br />Le lien reste.</strong></figcaption>
        </figure>
      </div>
    </section>
  );
}
